import { defineMessages } from 'react-intl';

export const quoteCardMessages = defineMessages({
  carrierNameLabel: {
    id: 'DiUkYq',
    description: 'Carrier name label on freight quote card',
    defaultMessage: 'Carrier',
  },
  serviceNameLabel: {
    id: 'KNvUGu',
    description: 'Service name label on freight quote card',
    defaultMessage: 'Service',
  },
  totalChargesLabel: {
    id: 'F0LiX/',
    description: 'Total charges label on freight quote card',
    defaultMessage: 'Total',
  },
  transitDays: {
    id: 'jGn7fP',
    description: 'Transit days value on freight quote card',
    defaultMessage: '{days, plural, one {# day} other {# days}}',
  },
  estimatedDeliveryLabel: {
    id: 'qKNBY8',
    description: 'Estimated delivery label on freight quote card',
    defaultMessage: 'Est. Delivery',
  },
  guaranteedBadge: {
    id: 'MayNq6',
    description: 'Guaranteed service badge on freight quote card',
    defaultMessage: 'Guaranteed',
  },
  viewDetailsButton: {
    id: '0rzg3/',
    description: 'View details button on freight quote card',
    defaultMessage: 'View Details',
  },
});
